<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Phone Number Change Pending
        </template>

        <template #content>
            <div>
                Your phone number is currently awaiting an update by phone carriers.<br />
            </div>
        </template>

        <template #footer>
            <a href='#' class="mr-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" 
                v-on:click="openIntercom" 
            >
                Contact Support
            </a>

            <jet-secondary-button class='ml-8' @click.native="$emit('close')" >
                Okay
            </jet-secondary-button>
        </template>
    </jet-dialog-modal>

</template>


<script>
import JetDialogModal from '../../Jetstream/DialogModal';
import JetSecondaryButton from '../../Jetstream/SecondaryButton';

export default {
    name: 'PhoneNumberPendingTcrUpdateModal',
    emits: ['close'],
    components: {
        JetDialogModal,
        JetSecondaryButton,
    },
    methods: {
        openIntercom() {
            window.Intercom('showNewMessage');
        }
    },
    computed: {
    }

}
</script>